import {
	STATE_DIRECT_LINK_ONLY,
	STATE_LOADING,
	STATE_UNAVAILABLE,
} from "@escapio/portal/state/HotelPriceLoadingStates";

export const CHRONOLOGICAL = "chronological";
export const BY_POPULARITY = "popular";
export const BY_PRICE_AND_POPULARITY = "price";
export const BY_PRICE_AND_CHRONOLOGICAL = "price_and_chronological";
export const BY_SCORE_AND_POPULARITY = "score";
export const BY_SCORE_AND_CHRONOLOGICAL = "score_and_chronological";

const getBestPrice = pricesForHotel =>
	pricesForHotel?.offers?.[0].total_rate || Infinity;

const createSorter = (getter, ascending) => {
	return (prices, hasDates) => (a, b) => {
		const getterA = getter(a, prices, hasDates);
		const getterB = getter(b, prices, hasDates);

		if (getterA === getterB) {
			return 0;
		}
		return getterA < getterB != ascending ? -1 : 1;
	};
};

const byPopularity = createSorter((hotel, prices, hasDates) => {
	const malus = !hasDates
		? 0
		: prices[hotel.id]?.pricesState === STATE_LOADING
			? 2_000_000
			: prices[hotel.id]?.pricesState === STATE_DIRECT_LINK_ONLY &&
				  !hotel.disabled_prices
				? 3_000_000
				: prices[hotel.id]?.pricesState === STATE_UNAVAILABLE &&
					  !hotel.disabled_prices
					? 4_000_000
					: 0;
	return hotel.ranking - malus;
}, true);
const byPrice = createSorter(
	(hotel, prices, hasDates) =>
		!hasDates
			? 0
			: hotel.disabled_prices
				? Number.MAX_SAFE_INTEGER - 3
				: prices[hotel.id]?.pricesState === STATE_LOADING
					? Number.MAX_SAFE_INTEGER - 2
					: prices[hotel.id]?.pricesState === STATE_DIRECT_LINK_ONLY
						? Number.MAX_SAFE_INTEGER - 1
						: prices[hotel.id]?.pricesState === STATE_UNAVAILABLE
							? Number.MAX_SAFE_INTEGER
							: getBestPrice(prices[hotel.id]),
	false,
);
const byScore = createSorter(hotel => hotel.review_score, true);
const chronological = createSorter(hotel => hotel.state.timeOrder, false);

const compose =
	(...sorters) =>
	(prices, hasDates) =>
	(a, b) =>
		sorters.reduce(
			// pass objects to next sorter until they are ordered.
			(compareResult, sorter) =>
				compareResult !== 0 ? compareResult : sorter(prices, hasDates)(a, b),
			0,
		);

export const sorters = Object.freeze({
	[BY_POPULARITY]: byPopularity,
	[BY_PRICE_AND_POPULARITY]: compose(byPrice, byPopularity),
	[BY_PRICE_AND_CHRONOLOGICAL]: compose(byPrice, chronological),
	[BY_SCORE_AND_POPULARITY]: compose(byScore, byPopularity),
	[BY_SCORE_AND_CHRONOLOGICAL]: compose(byScore, chronological),
	[CHRONOLOGICAL]: chronological,
});
